import QuestionViewVerbalTime from "./QuestionViewVerbalTime";

export default class QuestionViewVerbalClockFace extends QuestionViewVerbalTime{
    constructor(question) {
        super(question);
    }

    initFooter() {
        this._footer = new PIXI.Container();
        this.addChild(this._footer);

        this._footer.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("answer_box_9slice"), 88, 88, 88, 88);
        this._footer.image.position.set(0);
        this._footer.image.width = 820;
        this._footer.image.pivot.set(this._footer.image.width * 0.5, this._footer.image.height * 0.5);
    }

    initInputField() {
        this._inputField = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._inputField.anchor.set(0.5);
        this._footer.addChild(this._inputField);
    }

    setAnswer(value) {
        this._inputValue = value;
    }

    filterTemplate(x) {
        return true;
    }
}